import type { FC } from "react";
import { Chip } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { formatTrend, type TrendTone } from "../model";

const CHIP_COLOR = {
  success: "success",
  error: "error",
  neutral: "default",
} as const;

/**
 * Изменение к прошлому периоду: стрелка и процент. Цвет приходит из
 * модели (tone), здесь его не пересчитываем.
 */
export const TrendChip: FC<{ trend: number | null; tone: TrendTone }> = ({
  trend,
  tone,
}) => {
  if (trend === null) return null;
  const Icon =
    trend > 0
      ? TrendingUpIcon
      : trend < 0
        ? TrendingDownIcon
        : TrendingFlatIcon;
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<Icon />}
      label={formatTrend(trend)}
      color={CHIP_COLOR[tone]}
    />
  );
};
